'use client';
import axios, { endpoints } from 'src/utils/axios';
import { adminApiService } from 'src/lib/admin-api';
import { STORAGE_KEY } from './constant';
import { setSession } from './utils';

/** **************************************
 * Admin Sign in
 *************************************** */
export const adminSignInWithPassword = async ({ email, password }) => {
  try {
    const { access_token, user } = await adminApiService.signIn(email, password);

    if (!access_token) {
      throw new Error('Access token not found in response');
    }

    setSession(access_token);

    // Store user data in local storage (shared across tabs)
    if (typeof window !== 'undefined') {
      localStorage.setItem('admin_user', JSON.stringify(user));
    }

    return { user, accessToken: access_token };
  } catch (error) {
    console.error('Error during admin sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }) => {
  try {
    const params = { email, password };
    const res = await axios.post(endpoints.auth.signIn, params);
    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({ email, password, firstName, lastName }) => {
  try {
    const params = { email, password, firstName, lastName };
    const res = await axios.post(endpoints.auth.signUp, params);
    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, accessToken);
    }
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
